import { ServiceMaker, methods, services } from "@/services";

export const listTaxcode = id =>
  ServiceMaker(`/cpq/tax-codes/view`, methods.GET, services.master);

export const createTaxcode = payload =>
  ServiceMaker(
    `/cpq/tax-codes/create`,
    methods.PUT,
    services.master,
    payload
  );

export const updateTaxcode = payload =>
  ServiceMaker(
    `/cpq/tax-codes/edit`,
    methods.PATCH,
    services.master,
    payload
  );

export const deleteTaxcode = Id =>
  ServiceMaker(`/cpq/tax-codes/remove`, methods.DELETE, services.master, {
    _id: Id
  });
